import styled from '@emotion/styled';

interface PropTypes {
  collapsedHeight: number;
}

export const CollapsableContent = styled.div<PropTypes>`
  position: relative;
  height: ${({ collapsedHeight }) => `${collapsedHeight}px`};
  padding: 0;
  margin-bottom: 16px;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10px;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }

  &.open {
    height: auto;

    &:after {
      display: none;
    }
  }
`;

CollapsableContent.displayName = 'CollapsableContent';
